import { ILLCompany } from './index';
import { ILLEstablishment } from './ll-establishment.model';

export class ILLCustomerCompaniesByTypeWrapper {
  registrants: ILLCompany[];
  labelers: ILLCompany[];
  importers: ILLCompany[];
  usAgents: ILLCompany[];
  establishments: ILLEstablishment[];
  establishmentsThirdParty: ILLEstablishment[];
  establishmentOwnedAndEstablishmentThirdParty: ILLEstablishment[];
}
